import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import { communicationQueryKeys } from '@/queries/communication/communication.keys';

export const settingsQueries = {
  settings: () =>
    queryOptions({
      queryKey: communicationQueryKeys.getSettings(),
      queryFn: () => api.communication.getSettings(),
      retry: 0,
      enabled: () => !!localStorage.getItem('token'),
    }),
};

const useSettingsQuery = () => {
  return useQuery(settingsQueries.settings());
};

export { useSettingsQuery };
